import { Container, Stack } from '@mui/material';
import FileUploaderDropZone from 'Global/Components/CommonComponents/FileUploaderDropDown/FileUploaderDropZone';

import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

import React, { useEffect, useState } from 'react';
import FileInformation from './Components/FileInformation';
import useGetFileTypeArchive from './Hooks/useGetFileTypeArchive';
import useHandleFormData from './Hooks/useHandleFormData';
import { closeUploadDrawer } from './Shared/close.uploader.trigger';
import { useAtom } from 'jotai';
import FileArchiveList from '../FileArchive/Components/FileArchiveList/FileArchiveList';

export default function SendFileArchive() {
  function isPdfFile(fileName) {
    const extension = fileName.split('.').pop();
    return extension === 'pdf';
  }

  function checkProperties(obj) {
    if (obj.IdType && obj.NameType && obj.Description) {
      return true;
    } else {
      return false;
    }
  }

  useGetFileTypeArchive();
  const [fileSelected, setFileSelected] = useState(null);

  const selectFile_label = FindLangKey(
    'general-public-select-description'
  );

  const [formProps, setFromProps] = useHandleFormData();

  const enableSubmitBtn = checkProperties(formProps);

  const [file] = useAtom(closeUploadDrawer);

  const sentItems_label = FindLangKey(
    'genral-public-label-sent-items'
  );

  return (
    <>
      <Container>
        <Stack gap=".5em">
          <FileUploaderDropZone
            label={selectFile_label}
            stateLift={setFileSelected}
            onChange={(val) => {
              setFromProps((prev) => ({
                ...prev,
                base64File: val.fileContent,
                ImageOrFile: !isPdfFile(val.fileName),
              }));
            }}
            excludeHeader={true}
            resetState={file}
          />
          {fileSelected?.fileContent ? (
            <FileInformation
              fileSelected={fileSelected}
              formProps={formProps}
              setFromProps={setFromProps}
              enableSubmitBtn={enableSubmitBtn}
            />
          ) : (
            <Stack sx={{ mt: '1em' }}>
              {/* <p>{sentItems_label}</p> */}
              <FileArchiveList />
            </Stack>
          )}
        </Stack>
      </Container>
    </>
  );
}

// const { control, formState, watch, reset } = useForm({
//   defaultValues: {
//     IdType: '',
//     NameType: '',
//     NameFile: '',
//     Description: '',
//     DateImage: '',
//   },
// });

{
  /* <SingleReactHookFormWrapper
            element={<></>}
            control={control}
            errors={formState.errors}
            name="Mobile"
            isPassword={false}
            required={false}
          /> */
}
